<div class="modal-body">
  <form [formGroup]="form">
    <div class="row mb-3 gy-2">
      <div class="col-lg-6">
        <input-field
          type="text"
          [label]="'Sequence No'"
          placeholder="Enter Sequence No"
          formControlName="seqNo"
          [requiredLabel]="true"
          [errormessage]="'Sequence number is required'"
        ></input-field>
      </div>
      <div class="col-lg-6">
        <generic-dropdown
          [items]="projectLocations$ | async"
          [label]="'Location'"
          [allowSearch]="true"
          [clearable]="true"
          [required]="true"
          [placeholder]="'Select Location'"
          [errormessage]="'Location is required'"
          formControlName="locationId"
        >
        </generic-dropdown>
      </div>
      <div class="col-lg-6">
        <generic-dropdown
          [items]="elevationsDisplay()"
          [label]="'Elevation'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select Elevation'"
          formControlName="elevationId"
        ></generic-dropdown>
      </div>
      <div class="col-lg-12">
        <label class="form-label">Description</label>
        <textarea
          rows="3"
          class="form-control"
          placeholder="write notes here..."
          formControlName="description"
        ></textarea>
      </div>
    </div>
    @if (form.controls.estimates.touched && form.controls.estimates.invalid) {
      <div class="alert alert-danger py-2 mb-3">At least one estimate is required to save the room configuration.</div>
    }
  </form>

  <div class="d-flex flex-column">
    <form [formGroup]="estimate">
      <div class="bg-light p-3 rounded-4">
        <div class="d-flex align-items-center mb-3 gap-2">
          <i class="bi bi-calculator"></i>
          <h3 class="mb-0">Estimates</h3>
        </div>
        <div class="row gy-2">
          <div class="col-lg-6">
            <generic-dropdown
              [items]="categoryListByProductListId$ | async"
              [label]="'Category'"
              [allowSearch]="true"
              [clearable]="true"
              [placeholder]="'Select Category'"
              formControlName="categoryId"
              [required]="true"
              [errormessage]="'Category is required'"
              [optionAll]="true"
              [optionAllLabel]="'All Categories'"
              [selectFirstOption]="false"
            >
            </generic-dropdown>
          </div>
          <div class="col-lg-6">
            <generic-dropdown
              [items]="subcategories$ | async"
              [label]="'Subcategory'"
              [allowSearch]="true"
              [clearable]="true"
              [disabled]="!estimate.controls.categoryId.value"
              [placeholder]="'Select Subcategory'"
              formControlName="subCategoryId"
              [required]="true"
              [errormessage]="'Subcategory is required'"
              [optionAll]="true"
              [optionAllLabel]="'All Subcategories'"
              [selectFirstOption]="false"
            ></generic-dropdown>
          </div>
          <div class="col-lg-6">
            <generic-dropdown
              [items]="uofms$ | async"
              [label]="'UOM'"
              [allowSearch]="true"
              [clearable]="true"
              [placeholder]="'Select UOM'"
              formControlName="uofmId"
              [required]="true"
              [errormessage]="'UOM is required'"
            ></generic-dropdown>
          </div>
          <div class="col-lg-6">
            <input-field
              [label]="'Quantity'"
              [type]="'number'"
              [placeholder]="'Enter Quantity'"
              formControlName="quantity"
            ></input-field>
          </div>
          <div class="col mt-3">
            <div class="d-flex justify-content-end">
              @if (editEstimateId) {
                <button class="btn btn-primary btn-h35 fs-14" (click)="updateEstimate()">Update Estimate</button>
              } @else {
                <button class="btn btn-primary btn-h35 fs-14" (click)="addEstimate()">Add Estimate</button>
              }
            </div>
          </div>
        </div>
      </div>
    </form>

    @if (estimateArray.length > 0) {
      <div class="d-flex align-items-center gap-2 mt-4 mb-3">
        <i class="bi bi-calculator"></i>
        <h3 class="mb-0">Estimates</h3>
      </div>
      <div class="table-outer table-modal">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Category</th>
                <th>Subcategory</th>
                <th>UOM</th>
                <th>Quantity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (estimate of estimateArray; track estimate.id) {
                <tr>
                  <td>
                    {{
                      getCategoryDescription(categoryListByProductListId$ | async, estimate.categoryId) ||
                        getEstimateCategoryCode(estimate) ||
                        'All Categories'
                    }}
                  </td>
                  <td>
                    {{
                      getSubCategoryDescription(subcategories$ | async, estimate.subCategoryId) ||
                        getEstimateSubCategoryCode(estimate) ||
                        'All Subcategories'
                    }}
                  </td>
                  <td>
                    {{ getUofmDescription(uofms$ | async, estimate.uofmId) || getEstimateUofmCode(estimate) || '' }}
                  </td>
                  <td>{{ estimate.quantity }}</td>
                  <td>
                    <i class="bi bi-trash-fill text-danger ms-1 me-2" (click)="removeEstimate(estimate.id)"></i>
                    <i class="bi bi-pencil-square" (click)="editEstimate(estimate)"></i>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  @if (estimateArray.length === 0) {
    <div class="alert alert-warning py-2 m-2">
      <span class="fw-500 me-1">Warning:</span>Please add estimates in order to save the room configuration.
    </div>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-h42" (click)="close()">Cancel</button>
  <button class="btn btn-primary btn-h42" (click)="onSubmit()">Save</button>
</div>
